import React from 'react'
import SectionTitle from './SectionTitle';
import { TbBrandGithub }  from "react-icons/tb";
import { SlSocialYoutube, SlSocialLinkedin, SlSocialFacebook, SlSocialInstagram } from "react-icons/sl";
import { IoBuild } from "react-icons/io5";
import { RxOpenInNewWindow } from "react-icons/rx";

const projectDetails = [
    {
        id: "01",
        title: "Checkout",
        description: "A full-stack fintech application built with performance and security in mind. In this web application, I implemented Google Oauth, transaction queries, OTP, Idempotency, Paystack payment gateway, amongst other technologies.",
        demo: "/checkout.gif",
        tech: ["TypeScript", "PayStack", "Express", "Passport.js", "PostgreSQL", "React", "Node.js"],
        links: {
            github: "https://github.com/Bunmi194/checkout-backend-v1",
            live: "https://checkout-frontend-three.vercel.app/"
        }
    },
    {
        id: "02",
        title: "Chat-App",
        description: "Chat-App is a messaging application for real-time communication. This web application leveraged the power of socket.io for real-time communication.",
        demo: "/chatapp.gif",
        tech: ["MongoDB", "Express", "JavaScript", "React", "Node.js", "Socket.io", "Passport.js"],
        links: {
            github: "https://github.com/Bunmi194/chatApp",
            live: "https://chat-app-front-end-mu.vercel.app/"
        }
    },
    {
        id: "03",
        title: "Wallet",
        description: "This is a fronend only project built to showcase design, responsiveness and the implementation of different logics to achieve a web application that serves great user experience on the frontend.",
        demo: "/wallet.gif",
        tech: ["React", "Intercession Observer API", "Web API", "Tailwindcss"],
        links: {
            github: "https://github.com/Bunmi194/wallet",
            live: "https://wallet-six-plum.vercel.app/"
        }
    },
    {
        id: "04",
        title: "Homfy",
        description: "Built with PHP OOP, Homfy is a real-estate management web application that was integrated with Paystack.",
        demo: "/homfy.gif",
        tech: ["PHP", "MySQL", "HTML/CSS", "Bootstrap", "GSAP", "Paystack API", "Ajax"],
        links: {
            github: "https://github.com/Bunmi194/Bunmi194",
            live: "https://homfy-test.000webhostapp.com/index.php",
        }
    }
]
const Projects = () => {
  return (
    <section id="project" className='max-w-container lgl:px-20 py-24 mx-10'>
        <SectionTitle title="Some Things I have Built" emoji={<IoBuild />} />
        <div className='w-full flex flex-col items-center justify-between gap-28 mt-10' >
            {
                projectDetails.map(project=> {
                    return <div className='w-full flex flex-col items-center justify-center gap-0 mt-1 ml-10 px-10' style={{border: "0px solid red"}}>
                    <div className='flex flex-col xl:flex-row gap-2'>
                        
                        <div className='w-full xl:w-1/2 flex flex-col gap-0 lgl:justify-between xl:-ml-16 z-10 ml-0 pl-0' style={{border: "0px solid green"}}>
                            <span className='text-2xl font-bold'>{project.title}
                            </span>
                            <p className='bg-[#112240] text-sm md:text-base p-0 md:p-5 rounded-md'>
                            {project.description}
                            </p>
                            <ul className='text-xs md:text-sm font-titleFont tracking-wide flex gap-2 md:gap-5 justify-between text-textDark'>
                                {project.tech.map(tech => {
                                    return <li>{tech}</li>
                                })}
                            </ul>
                            <div className='text-2xl flex gap-4'>
                                <a className="hover:text-textGreen duration-300"
                                href={project.links.github} target="_blank" rel="noreferrer">
                                    <TbBrandGithub />
                                </a>
                                <a className="hover:text-textGreen duration-300"
                                href={project.links.live} target="_blank" rel="noreferrer">
                                    <RxOpenInNewWindow />
                                </a>
                            </div>
                        </div>
                        <div style={{border: "0px solid red"}}>
                            <a href={project.links.live} target="_blank" rel='noreferrer' className='cursor-pointer'>
                                <img className="w-[600px] h-[300px] object-cover p-4"
                                src={project.demo}
                                alt="demo"/>
                            </a>
                        </div>
                    </div>
    
                </div>
    
                })
            }
                    </div>

    </section>
  )
}

export default Projects